// ─────────────────────────────────────────────────────────────────────────────
// Day and night in the class ocean. It runs on the wall clock, so everyone sees
// the same sky: a 20-minute cycle of 8 minutes of day, 2 of dusk, 8 of night
// and 2 of dawn, so day and night get equal time (10 minutes each, counted
// from the middle of dusk and dawn). At night the upper water darkens, lights matter, and some
// deep-sea fish rise toward the surface (Species.night in lib/aquarium.ts).
// ─────────────────────────────────────────────────────────────────────────────

const CYCLE = 20 * 60;

/** 0 = full day, 1 = full night. */
export function nightness(now = Date.now() / 1000): number {
  const u = (now % CYCLE) / 60;   // minutes into the cycle
  if (u < 8) return 0;
  if (u < 10) return smooth((u - 8) / 2);
  if (u < 18) return 1;
  return 1 - smooth((u - 18) / 2);
}
const smooth = (k: number) => k * k * (3 - 2 * k);

/** Minutes until it next changes between day and night (for the HUD). */
export function untilChange(now = Date.now() / 1000): { night: boolean; minutes: number } {
  const u = (now % CYCLE) / 60;
  const night = u >= 9 && u < 19;
  const next = night ? 19 : u < 9 ? 9 : 9 + 20;
  return { night, minutes: Math.max(1, Math.ceil(next - u)) };
}
